module.exports = __webpack_public_path__ + "img/michelin_2.513e6d7d.png";